import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, List, ListItem, ListItemButton, ListItemText, CircularProgress } from "@mui/material";

export default function NoteVersions({ open, onClose, token, workspace, noteName, onRevert }) {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !token || !workspace || !noteName) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/notes/${encodeURIComponent(noteName)}/versions?workspace=${encodeURIComponent(workspace)}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          setVersions(data);
        } else {
          setVersions([]);
        }
        setLoading(false);
      })
      .catch(() => { setVersions([]); setLoading(false); });
  }, [open, token, workspace, noteName]);

  const handleRevert = async (versionId) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/notes/${encodeURIComponent(noteName)}/version/${versionId}?workspace=${encodeURIComponent(workspace)}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    onRevert(data);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Note Versions</DialogTitle>
      <DialogContent>
        {loading ? <CircularProgress size={24} /> : (
          <List dense>
            {versions.map(v => (
              <ListItem key={v.versionId} disablePadding secondaryAction={v.isLatest ? <span style={{fontSize:12, color:'#888'}}>Latest</span> : null}>
                <ListItemButton onClick={() => handleRevert(v.versionId)}>
                  <ListItemText
                    primary={new Date(v.lastModified).toLocaleString()}
                    secondary={v.versionId}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
        <Button onClick={onClose} sx={{ mt: 2 }} fullWidth variant="outlined">Close</Button>
      </DialogContent>
    </Dialog>
  );
}
